export const dashboard = {
  title: { en: 'Dashboard', ko: '대시보드', fr: '' },
  components: {
    aside: {
      menu1: { en: 'Dashboard', ko: '대시보드', fr: '' },
      menu2: { en: 'Alert', ko: '알림', fr: '' },
      menu3: { en: 'Event', ko: '이벤트', fr: '' },
      menu4: { en: 'Patient', ko: '환자', fr: '' },
      menu5: { en: 'Report', ko: '리포트', fr: '' },
      menu6: { en: 'Group', ko: '그룹', fr: '' },
      menu7: { en: 'Rules', ko: '권한', fr: '' },
      menu8: { en: 'Devices', ko: '장비', fr: '' },
      menu9: { en: 'Settings', ko: '설정', fr: '' },
      menu10: { en: 'Get Help', ko: '고객지원', fr: '' },
    },
    cards: {
      card1: {
        title: { en: 'Hospital', ko: '병원', fr: '' },
      },
      card2: {
        title: { en: 'Status', ko: '주요현황', fr: '' },
      },
      card3: {
        title: { en: 'Patient', ko: '환자', fr: '' },
      },
      card4: {
        title: { en: 'Device', ko: '장치', fr: '' },
      },
      card5: {
        title: { en: 'Data', ko: '데이터', fr: '' },
      },
      tabList: {
        tab1: {
          title: { en: 'MEK', ko: 'MEK', fr: '' },
        },
        tab2: {
          title: { en: 'MYSUUM', ko: '마이섬', fr: '' },
        },
        tab3: {
          title: { en: 'YOURSUUM', ko: '유어섬', fr: '' },
        },
        tab4: {
          title: { en: 'OURSUUM', ko: '우리섬', fr: '' },
        },
      },
    },
  },
  patient: { en: 'Patient', ko: '환자', fr: '' },
  device: { en: 'Devices', ko: '장비', fr: '' },
  data: { en: 'Data', ko: '데이터', fr: '' },
};
